import React, { Component } from 'react';
import { ComboBox, Stack } from 'office-ui-fabric-react/lib/index';

/*
***************************************************************
 PROPS:
    labelHeures
    onFocusHeure
    onBlurHeure
    onChangedHeure
    heures

    labelMinutes
    onFocusMinute
    onBlurMinute
    onChangedMinute
    minutes

    disabled
    required
***************************************************************
*/

export class TimePicker extends Component {

    static defaultProps = {
        labelHeures: "Heures",
        labelMinutes: "Minutes",
    };

    _getOptionsHeures = () => {
        let options = [];
        for (let i = 0; i < 24; i++) {
            const option = ((i < 10 ? '0' : '') + i).toString();
            options.push({
                key: option,
                text: option
            });
        }
        return options;
    };

    _getOptionsMinutes = () => {
        let options = [];
        for (var j = 0; j < 60; j++) {
            const option = ((j < 10 ? '0' : '') + j).toString();
            options.push({
                key: option,
                text: option
            });
        }
        return options;
    };

    render = () => <Stack horizontal gap={8}>
        <ComboBox
            autoComplete="on"
            disabled={this.props.disabled}
            label={this.props.labelHeures}
            onBlur={this.props.onBlurHeure}
            onChange={this.props.onChangeHeure}
            onFocus={this.props.onFocusHeure}
            options={this._getOptionsHeures()}
            required={this.props.required}
            selectedKey={this.props.heures}
        />
        <ComboBox
            autoComplete="on"
            disabled={this.props.disabled}
            label={this.props.labelMinutes}
            onBlur={this.props.onBlurMinute}
            onChange={this.props.onChangeMinute}
            onFocus={this.props.onFocusMinute}
            options={this._getOptionsMinutes()}
            required={this.props.required}
            selectedKey={this.props.minutes}
        />
    </Stack>;

}